import { BaseModel } from "@/models/base.model"
import { type IProduct } from "@/interfaces/api/product.interface"
import { Units } from "@/enums/units.enum"
import { unitToName } from "@/helper/enums/unit-helper.ts"

export class Product extends BaseModel implements IProduct {
  public static className = "Product"
  public static verboseName = "Product"

  name: string
  unit: Units

  constructor(product: IProduct) {
    super(product)

    this.name = product.name
    this.unit = product.unit
  }

  public getDisplayText() {
    return `${this.name} ${unitToName(this.unit)}`
  }
}
